import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { User } from "../../../@types/user";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const assignFormToUser = createAsyncThunk(
  "templateDetail/assignFormToUser",
  async (userRole: UserRole, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}formsubmitted`, {
        form: state.templateDetail.template.id,
        user: userRole.user.id,
      });
      return userRole;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
